module.exports = __webpack_public_path__ + "img/book-15.2a6e5694.png";